export default "__VITE_ASSET__y_73Ix7z__"